import { useState, useCallback } from 'react';
import { getServiceAnalisisRoles, postServiceAnalisisRoles, putServiceAnalisisRoles } from '../services/roles';

const useRoles = () => {
  const [state, setState] = useState({ loading: false, error: null, roles: [] });

  const getAnalisisRol = useCallback(async (data) => {
    setState({ loading: true, error: null, roles: [] });
    try {
      const roleService = await getServiceAnalisisRoles(data);
      setState({ loading: false, error: null, roleService });
      return roleService;
    } catch (e) {
      setState({ loading: false, error: e, roles: [] });
      return [];
    }
  });

  const createAnalisisRol = useCallback(async (data) => {
    setState({ loading: true, error: null });
    try {
      await postServiceAnalisisRoles(data);
      setState({ loading: false, error: null });
      return true;
    } catch (e) {
      setState({ loading: false, error: e });
      return false;
    }
  });

  const editAnalisisRol = useCallback(async (data) => {
    setState({ loading: true, error: null });
    try {
      await putServiceAnalisisRoles(data);
      setState({ loading: false, error: null });
      return true;
    } catch (e) {
      setState({ loading: false, error: e });
      return false;
    }
  });

  return {
    isAnalisisRolesLoading: state.loading,
    analisisRolesError: state.error,
    getAnalisisRol,
    editAnalisisRol,
    createAnalisisRol,
  };
};

export default useRoles;
